import React, { Component } from 'react';
import Search from '../components/search/search';
import Adapter from '../components/search/adapter';
import * as grpcWeb from 'grpc-web';
import Header from '../components/header';
import Footer from '../components/footer';
import { AdminServiceClient } from '../rpc/admin/AdminServiceClientPb';
import { SearchRequest, SearchResponse, AutocompleteRequest, AutocompleteResponse } from '../rpc/admin/search_pb';
import { getAuthMetadata } from '../helpers/rpc';
import Helmet from 'react-helmet';
import { PaddedContainer } from '../components/base';
import { withRouter, RouteComponentProps } from 'react-router-dom';

class CatalogProps { }

class CatalogState { }

class CatalogAdapter extends Adapter {

    protected performSearch(client: AdminServiceClient, request: SearchRequest): Promise<SearchResponse> {
        return new Promise((resolve, reject) => {
            client.productSearch(request, getAuthMetadata(), (err: grpcWeb.Error, response: SearchResponse) => {
                if (!err) {
                    resolve(response);
                } else {
                    reject(err);
                }
            });
        });
    }

    performAutocomplete(client: AdminServiceClient, request: AutocompleteRequest): Promise<AutocompleteResponse> {
        return new Promise((resolve, reject) => {
            client.productAutocomplete(request, getAuthMetadata(), (err: grpcWeb.Error, response: AutocompleteResponse) => {
                if (!err) {
                    resolve(response);
                } else {
                    reject(err);
                }
            });
        });
    }
}

class Catalog extends Component<CatalogProps & RouteComponentProps<any>, CatalogState> {

    private adapter: Adapter

    constructor(props: CatalogProps & RouteComponentProps<any>) {
      super(props);
      this.adapter = new CatalogAdapter(props.history);
    }

    private handleNewProduct = () => {
        this.props.history.push('/catalog/new');
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Catalog | Dashboard</title>
                </Helmet>

                <Header />

                <PaddedContainer>
                    <Search adapter={this.adapter} basePath="/catalog/">
                        <button className="button" title="New Product" onClick={this.handleNewProduct}>
                            New Product
                        </button>
                    </Search>
                </PaddedContainer>

                <Footer />
            </>
        );
    }
}

export default withRouter(Catalog);